export default __webpack_public_path__ + "static/media/png.a4666948.svg";